import { ISearchWidget } from 'features/search-widget';

const vrboSearchWidgetConfig: Record<string, ISearchWidget> = {
  // 'at-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003008&locale=de_AT&3ec60977',
  //       description: 'Vrbo AT',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/de-at',
  //     searchParams: {
  //       siteid: '9003008',
  //       langid: '1031',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'au-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9005024&locale=en_AU&3ec60977',
  //       description: 'Vrbo AU',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/en-au',
  //     searchParams: {
  //       siteid: '9005024',
  //       langid: '3081',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'br-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9007028&locale=pt_BR&3ec60977',
  //       description: 'Vrbo BR',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/pt-br',
  //     searchParams: {
  //       siteid: '9007028',
  //       langid: '1046',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  'ca-vrbo': {
    branding: {
      logo: {
        url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9002003&locale=en_CA&3ec60977',
        description: 'Vrbo CA',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.vrbo.com',
      pathname: '/en-ca',
      searchParams: {
        siteid: '9002003',
        langid: '4105',
      },
      stays: {
        pathname: '/search',
      },
    },
  },

  // 'dk-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9022026&locale=da_DK&3ec60977',
  //       description: 'Vrbo DK',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/da-dk',
  //     searchParams: {
  //       siteid: '9022026',
  //       langid: '1030',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'es-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003009&locale=es_ES&3ec60977',
  //       description: 'Vrbo ES',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/es-es',
  //     searchParams: {
  //       siteid: '9003009',
  //       langid: '3082',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'fi-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003017&locale=fi_FI&3ec60977',
  //       description: 'Vrbo FI',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/fi-fi',
  //     searchParams: {
  //       siteid: '9003017',
  //       langid: '1035',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'gr-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003019&locale=el_GR&3ec60977',
  //       description: 'Vrbo GR',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/el-gr',
  //     searchParams: {
  //       siteid: '9003019',
  //       langid: '1032',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'it-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003011&locale=it_IT&3ec60977',
  //       description: 'Vrbo IT',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/it-it',
  //     searchParams: {
  //       siteid: '9003011',
  //       langid: '1040',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'jp-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9009032&locale=ja_JP&3ec60977',
  //       description: 'Vrbo JP',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/ja-jp',
  //     searchParams: {
  //       siteid: '9009032',
  //       langid: '1041',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'mx-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9001005&locale=es_MX&3ec60977',
  //       description: 'Vrbo MX',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/es-mx',
  //     searchParams: {
  //       siteid: '9001005',
  //       langid: '2058',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'nl-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003016&locale=nl_NL&3ec60977',
  //       description: 'Vrbo NL',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/nl-nl',
  //     searchParams: {
  //       siteid: '9003016',
  //       langid: '1043',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'no-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9021025&locale=no_NO&3ec60977',
  //       description: 'Vrbo NO',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/no-no',
  //     searchParams: {
  //       siteid: '9021025',
  //       langid: '1044',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'nz-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9006029&locale=en_NZ&3ec60977',
  //       description: 'Vrbo NZ',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/en-nz',
  //     searchParams: {
  //       siteid: '9006029',
  //       langid: '5129',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'pl-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003018&locale=pl_PL&3ec60977',
  //       description: 'Vrbo PL',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/pl-pl',
  //     searchParams: {
  //       siteid: '9003018',
  //       langid: '1045',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'pt-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9003015&locale=pt_PT&3ec60977',
  //       description: 'Vrbo PT',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/pt-pt',
  //     searchParams: {
  //       siteid: '9003015',
  //       langid: '2070',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'se-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9023027&locale=sv_SE&3ec60977',
  //       description: 'Vrbo SE',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/sv-se',
  //     searchParams: {
  //       siteid: '9023027',
  //       langid: '1053',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  // 'sg-vrbo': {
  //   branding: {
  //     logo: {
  //       url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9008031&locale=en_SG&3ec60977',
  //       description: 'Vrbo SG',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'www.vrbo.com',
  //     pathname: '/en-sg',
  //     searchParams: {
  //       siteid: '9008031',
  //       langid: '18441',
  //     },
  //     stays: {
  //       pathname: '/search',
  //     },
  //   },
  // },

  'uk-vrbo': {
    branding: {
      logo: {
        url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9004006&locale=en_GB&3ec60977',
        description: 'Vrbo UK',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.vrbo.com',
      pathname: '/en-gb',
      searchParams: {
        siteid: '9004006',
        langid: '2057',
      },
      stays: {
        pathname: '/search',
      },
    },
  },

  'us-vrbo': {
    branding: {
      logo: {
        url: 'https://www.vrbo.com/_dms/header/logo.svg?siteid=9001001&locale=en_US&3ec60977',
        description: 'Vrbo US',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.vrbo.com',
      searchParams: {
        siteid: '9001001',
        langid: '1033',
      },
      stays: {
        pathname: '/search',
      },
    },
  },
};

export { vrboSearchWidgetConfig };
